import { useIsStoreAliasFirst } from 'hooks/business/store/useStoreName';
import { useGetReasonLabel } from 'hooks/business/refundReason/useGetReasonLabel';
import { useGetRegionLabel } from 'hooks/business/useRegion';
import { useGetMercadoReasonLabel } from 'hooks/business/refundReason/useGetMercadoReasonLabel';
import { useReturnTypeDisplay } from 'views/Refund/hooks/useReturnTypeDisplay';

/** 退货单条目的文案与标签（单一职责：店铺名、地区、原因、退货类型等展示文案） */
export function useReturnItemLabels(params: {
  platform: General.PlatformUpperCase;
  region: General.Region;
  storeName: string;
  storeAlias: string;
}) {
  const { platform, region, storeName, storeAlias } = params;

  const showAlias = useIsStoreAliasFirst(platform, region);
  const name = showAlias && storeAlias ? storeAlias : storeName;

  const getRegionLabel = useGetRegionLabel();
  const { getReasonLabel } = useGetReasonLabel();
  const getMercadoReasonLabel = useGetMercadoReasonLabel();
  const returnTypeDisplay = useReturnTypeDisplay();

  return {
    /** 展示用店铺名（优先别名） */
    storeDisplayName: name,
    getRegionLabel,
    getReasonLabel,
    getMercadoReasonLabel,
    returnTypeDisplay,
  };
}
